module.exports = __webpack_public_path__ + "static/media/Interactive Dashboards.c451f6aa.svg";